<template>
  <QuestionYesNo
    title="Is Discrete"
    :question="{ options: options, designator: 'is_discrete' }"
    :initValue="initValue"
    @input="handleChange"
  />
</template>

<script>
import QuestionYesNo from '@/components/QuestionYesNo'

export default {
  name: 'IsDiscrete',
  components: {
    QuestionYesNo
  },
  props: {
    value: {
      type: Boolean
    },
    applicantId: {
      type: Number
    }
  },
  data () {
    return {
      options: [
        { id: 'true', text: 'true' },
        { id: 'false', text: 'false' }
      ]
    }
  },
  computed: {
    initValue () {
      return this.value ? 'true' : 'false'
    }
  },
  methods: {
    async handleChange (data) {
      try {
        let v = data.answer
        await this.$network_utils.updateApplicant({ applicant_id: this.applicantId, is_discrete: v })
        this.$emit('input', v)
        this.$utils.emit('show_toast', { text: 'הצלחה' })
      } catch (e) {
        console.log(e)
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
